import styles from "./BillingCard.module.scss";
import { IPaymentMethod } from "../../../../models/Stripe";
import React, { useState } from "react";
import deleteIcon from "../../../../assets/images/icons/delete-white.svg";
import moreIcon from "../../../../assets/images/icons/more.svg";
import { useTranslation } from "react-i18next";
import ConfirmPopup from "../../../../components/shared/ConfirmPopup/ConfirmPopup";
import attentionPath from "../../../../assets/images/icons/attention.svg";
import useAppDispatch from "../../../../hooks/useAppDispatch";
import { useStripeMutations } from "../../../../api/mutations";
import { openSuccessMessage } from "../../../../store/message/messageSlice";
import { handleError } from "../../../../helper/errorHandler";
import FullScreenLoader from "../../../../components/shared/FullScreenLoader/FullScreenLoader";

interface IBillingCardProps {
  paymentMethod: IPaymentMethod;
  getAllPaymentMethod: () => void;
}

const BillingCard: React.FC<IBillingCardProps> = ({ paymentMethod, getAllPaymentMethod }) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const [showMoreMenu, setShowMoreMenu] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showConfirmPopup, setShowConfirmPopup] = useState(false);
  const { setAsDefault, detach } = useStripeMutations();

  const changeMenuVisible = (value: boolean) => {
    setShowMoreMenu(value);
  };

  const setAsDefaultFn = async () => {
    setLoading(true);
    setAsDefault(paymentMethod.id, {
      onSuccess: () => {
        dispatch(openSuccessMessage(t("DefaultPaymentMethodChanged")));
        getAllPaymentMethod();
        setLoading(false);
      },
      onError: (e) => {
        setLoading(false);
        handleError(e, dispatch, t);
      },
    });
  };

  const closeConfirmPopup = () => {
    setShowConfirmPopup(false);
  };

  const openConfirmPopup = () => {
    setShowConfirmPopup(true);
  };

  const confirmForDelete = () => {
    setShowConfirmPopup(false);
    setLoading(true);
    detach(paymentMethod.id, {
      onSuccess: () => {
        dispatch(openSuccessMessage(t("CardDeletedSuccessfully")));
        getAllPaymentMethod();
        setLoading(false);
      },
      onError: (e) => {
        setLoading(true);
        handleError(e, dispatch, t);
      },
    });
  };

  return (
    <>
      <div key={paymentMethod.id} className={styles.item}>
        {showConfirmPopup && (
          <ConfirmPopup
            iconPath={attentionPath}
            title={t("DeletingConfirmation") + "!"}
            description={t("AreYouSureYouWantDeleteThisCard")}
            onClickYes={confirmForDelete}
            onClickNo={closeConfirmPopup}
          />
        )}
        <div className={styles.itemTop}>
          <p className={styles.default}>{paymentMethod.isDefault && t("Default")}</p>
          <div className={styles.iconWrapper}>
            {/*<img onClick={() => clickOnEdit(paymentMethod.id)} src={editIcon} alt={"edit"}/>*/}
            <img onClick={() => openConfirmPopup()} src={deleteIcon} alt={"delete"} />
            {!paymentMethod.isDefault && (
              <div
                className={`${styles.moreContainer} ${showMoreMenu && styles.active}`}
                onClick={() => changeMenuVisible(!showMoreMenu)}
              >
                <img className={styles.moreImage} src={moreIcon} alt={"more"} />
                <ul className={styles.moreMenu}>
                  <li onClick={() => setAsDefaultFn()} className={styles.moreMenuItem}>
                    {t("SelectAsDefault")}
                  </li>
                </ul>
              </div>
            )}
          </div>
        </div>
        <div className={styles.itemMain}>
          <p className={`${styles.text} ${styles.minWidth}`}>{paymentMethod.nameOnCard}</p>
        </div>
        <div className={styles.itemBottom}>
          <p className={styles.text}>****</p>
          <p className={styles.text}>****</p>
          <p className={styles.text}>****</p>
          <p className={styles.text}>{paymentMethod.last4}</p>
        </div>
        <img className={styles.cardBrand} src={paymentMethod.brandIconUrl} alt={"brand"} />
      </div>
      {loading && <FullScreenLoader />}
    </>
  );
};

export default BillingCard;
